<template>
    <div class="modal relative">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Notes</h1>
            </div>

            <div class="modal-body no-pad">

                <NoteCreate
                    @created="handleCreatedNote"
                />
                <template v-if="notes">
                    <NoteEntry
                        v-for="note in notes"
                        :key="note.id"
                        :note="note"
                        @deleted="handleDeletedNote"
                    />
                </template>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
import NoteEntry from './Notes/NoteEntry'
import NoteCreate from './Notes/NoteCreate'

export default {
    name: 'NotesDrawer',
    components: {NoteCreate, NoteEntry},
    props: {
        //
    },
    data() {
        return {
            notes: [],
            authoringNewNote: false,
            newNoteContent: null,
        }
    },
    mounted() {
        this.setMetaTitle('View Account Notes | JournoLink Control')
        this.loadData()
    },
    methods: {
        loadData() {
            axios.get(route('accounts.notes.list', this.$route.params.accountId))
                .then(response => {
                    this.notes = response.data.data
                })
                .catch(e => {
                    console.error({e})
                })
        },

        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },

        /**
         * Handle a new note being created and add to the list.
         *
         * @param {Object} note
         * @return {void}
         */
        handleCreatedNote(note) {
            this.notes.unshift(note)
        },

        /**
         * Handles a note being deleted and removes from the list.
         *
         * @param {Object} note
         * @return {void}
         */
        handleDeletedNote(note) {
            this.notes = this.notes.filter(n => n.id !== note.id)
        },
    },
}
</script>
